var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid text-center",attrs:{"id":"bottomFooter"}},[_vm._v("\n    © Netto Marken-Discount Stiftung & Co. KG\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }